import ConfirmModal from 'components/modals/ConfirmModal';
import React from 'react';
import { ModalState } from 'records/ModalState';
import { Submittal } from 'records/Submittal';
import * as toast from 'utils/toast';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';
import { useTranslator } from '@bluebeam/react-i18n';
import { FeatureFlag, useFeatureFlags } from 'featureFlags';

interface Props extends WithAppStoreProps {
  submittal: Submittal;
}

const DeleteSubmittalButton = (props: Props) => {
  const { translate } = useTranslator(['submittalsPage', 'toastText']);
  const { [FeatureFlag.GodMode]: isGodModeEnabled } = useFeatureFlags();
  const HandleDeleteSubmittal = (): void => {
    const { submittal, actions } = props;
    const modalState = new ModalState({
      id: 'ConfirmSubmittalDelete',
      portal: 'main',
      open: true,
      component: ConfirmModal,
      props: {
        acceptButtonText: 'Delete',
        denyButtonText: 'Cancel',
        headerText: 'Delete Submittal',
        content: 'Are you sure you would like to delete this Submittal?',
        acceptCallback: async (): Promise<void> => {
          try {
            actions.clearAllModals();
            await actions.deleteSubmittal(submittal);
            actions.clearInteractions();
          } catch (err) {
            toast.error(
              translate('toastText:submittalDeleteError.message'),
              translate('toastText:submittalDeleteError.title')
            );
            console.log('unable to delete submittal', err);
          }
        },
        denyCallback: (): void => {
          actions.clearAllModals();
        },
      },
    });

    actions.createModal(modalState);
  };

  return isGodModeEnabled ? (
    <div
      className="hs3 light b-solid b-width-2 b-error b-radius-2 flex-center color-error cursor-pointer bgd-error-tint-90-h"
      onClick={HandleDeleteSubmittal}
    >
      <div className="row items-center ">
        {translate('submittalsPage:deleteSubmittal')}
      </div>
    </div>
  ) : null;
};

export default withAppStore<Props>(DeleteSubmittalButton);
